import classnames from 'classnames';
import React, { useCallback, useEffect, useRef } from 'react';
import { getIconBaseUrl } from '../../utils/assets';
import Heading from '../Heading';
import styles from './OverlayPanel.module.scss';
import { DesktopVariants } from './types';
import { desktopVariantClasses, levelClasses } from './util';
export const OverlayPanel = (props) => {
    const { id, open = false, close, done, backButton = false, closeButton = false, backButtonLabel = '', title = '', level = 1, children, alert, setPanelOpen, additionalClass = '', doneButtonLabel = 'Done', showContentOnDesktop = false, desktopVariant = DesktopVariants.HIDDEN, additionalFooterCtaLabel, disableDoneButton = false, additionalFooterCtaOnClick, CustomFooterComponent, showHeader = true, showFooter = true, quickDismiss = true, } = props;
    const backButtonRef = useRef(null);
    const closeButtonRef = useRef(null);
    useEffect(() => {
        open && document.body.classList.add(`bl-haven-overlay${level}Open-${desktopVariant}`);
        !open && document.body.classList.remove(`bl-haven-overlay${level}Open-${desktopVariant}`);
        if (open && (backButtonRef === null || backButtonRef === void 0 ? void 0 : backButtonRef.current))
            backButtonRef.current.focus();
        if (open && (closeButtonRef === null || closeButtonRef === void 0 ? void 0 : closeButtonRef.current))
            closeButtonRef.current.focus();
        return () => {
            document.body.classList.remove(`bl-haven-overlay${level}Open-${desktopVariant}`);
        };
    }, [open, level, desktopVariant, backButtonRef, closeButtonRef]);
    const onDesktopAndSafeToClose = (desktopVariant === DesktopVariants.POPUP ||
        desktopVariant === DesktopVariants.OVERLAY_FORM ||
        desktopVariant === DesktopVariants.OVERLAY_FORM_LARGE) &&
        ((open && done) || setPanelOpen) &&
        quickDismiss;
    const closeOverlay = useCallback(() => {
        if (close) {
            return close();
        }
        if (done) {
            return done(false);
        }
        if (setPanelOpen) {
            return setPanelOpen(false);
        }
        return null;
    }, [close, done, setPanelOpen]);
    const escFunction = useCallback((event) => {
        if (event.key === 'Escape' && onDesktopAndSafeToClose) {
            closeOverlay();
        }
    }, [onDesktopAndSafeToClose, closeOverlay]);
    useEffect(() => {
        document.addEventListener('keydown', escFunction);
        return () => {
            document.removeEventListener('keydown', escFunction);
        };
    }, [escFunction]);
    const checkAndCloseModal = (e) => {
        // Only fire when clicking the 'outside' of the scroll
        if (e.target.className === styles.scroll && onDesktopAndSafeToClose) {
            closeOverlay();
        }
    };
    return (<>
      {(open || showContentOnDesktop) && (<div id={id} className={classnames(styles.blHavenOverlayPanel, open && styles.panelOpen, showContentOnDesktop && styles.showContentOnDesktop, done && styles.buttonDone, additionalFooterCtaLabel && styles.buttonAdditional, level && levelClasses[level], desktopVariant && desktopVariantClasses[desktopVariant], additionalClass)}>
          <div onKeyDown={() => {
                // To appease
            }} className={styles.scroll} tabIndex={0} role='button' onClick={checkAndCloseModal}>
            {(desktopVariant === DesktopVariants.POPUP ||
                desktopVariant === DesktopVariants.OVERLAY_FORM ||
                desktopVariant === DesktopVariants.OVERLAY_FORM_LARGE) &&
                open &&
                done && (<button type='button' className={styles.sheetCloseButton} onClick={closeOverlay}>
                  <span className='srOnly'>Close</span>
                </button>)}
            <div className={styles.inner}>
              {closeButton && done && (<button type='button' className={styles.closeButton} onClick={closeOverlay} ref={closeButtonRef}>
                  <img className={styles.closeButtonIcon} src={getIconBaseUrl('close.svg')} alt='Close'/>
                </button>)}
              {showHeader && (<div className={styles.header}>
                  {title && (<Heading className={styles.title} level={7} scale={0}>
                      {title}
                    </Heading>)}
                  {backButton && (<button onClick={() => setPanelOpen && setPanelOpen(false)} type='button' className={styles.backButton} ref={backButtonRef}>
                      <img className={styles.backArrow} src={getIconBaseUrl('arrow-ios-left-darkblue.svg')} alt='go back'/>
                      {backButtonLabel}
                    </button>)}
                </div>)}
              {alert && <div className={styles.alert}>{alert}</div>}
              <div className={styles.content} data-testid='overlayPanel__content'>
                {children}
              </div>
              {showFooter &&
                (CustomFooterComponent ? (<footer className={styles.footer}>
                    <CustomFooterComponent {...props}/>
                  </footer>) : (<footer className={classnames(styles.footer, additionalFooterCtaLabel && styles.double)}>
                    {done && additionalFooterCtaLabel && (<button onClick={() => done(false)} className={styles.simpleButton}>
                        {additionalFooterCtaLabel}
                      </button>)}
                    {done && !disableDoneButton && (<button className={styles.doneButton} onClick={() => additionalFooterCtaOnClick
                            ? additionalFooterCtaOnClick(false)
                            : done(false)} type='button'>
                        {doneButtonLabel}
                      </button>)}
                  </footer>))}
            </div>
          </div>
        </div>)}
    </>);
};
